import React from "react";
import { useConnection } from "../../context/ConnectionContext";

const styles = {
  checking: "bg-sky-50 text-sky-800 border-sky-100",
  reconnecting: "bg-amber-50 text-amber-800 border-amber-100",
  slow: "bg-yellow-50 text-yellow-800 border-yellow-100",
  offline: "bg-red-50 text-red-800 border-red-100",
  server_down: "bg-orange-50 text-orange-800 border-orange-100",
};

const dots = {
  checking: "bg-sky-500 animate-pulse",
  reconnecting: "bg-amber-500 animate-pulse",
  slow: "bg-yellow-500 animate-pulse",
  offline: "bg-red-500",
  server_down: "bg-orange-500 animate-pulse",
};

/**
 * Notif status koneksi. Sengaja BUKAN `fixed` — app shell dikunci max-width
 * 430px & di-tengah (lihat #root di index.css), sedangkan `fixed` menghitung
 * posisi terhadap viewport browser penuh. Di layar lebar (atau beberapa
 * browser HP) itu bikin banner melenceng dari kolom app dan menutupi/kepotong
 * di tepi. Pakai `sticky` supaya lebar & posisi horizontalnya selalu ikut
 * container app (in-flow, tidak mungkin keluar batas), tapi tetap nempel di
 * atas layar saat halaman di-scroll.
 */
export default function ConnectionBanner() {
  const { status, copy } = useConnection();

  if (!copy || status === "online" || status === "checking") return null;

  return (
    <div className={`sticky top-0 z-50 w-full border-b px-3.5 py-2.5 animate-fade-up ${styles[status]}`}>
      <div className="flex items-start gap-2.5 mx-auto max-w-[430px]">
        <span className={`mt-1 h-2 w-2 rounded-full shrink-0 ${dots[status]}`} />
        <div className="min-w-0 flex-1">
          <p className="text-[11px] font-black uppercase tracking-wider break-words">{copy.title}</p>
          <p className="text-[11px] font-semibold leading-snug mt-0.5 break-words">{copy.message}</p>
        </div>
      </div>
    </div>
  );
}
